import FeedPostbox from './FeedPostbox';
import FeedPostboxContainer from './FeedPostbox.container';

export default FeedPostboxContainer(FeedPostbox);
